import { useEffect, useMemo, useRef, useState } from "react";
import { glyph, KEY } from "./logEngine";

// Each character scrambles through random glyphs for ~300 ms, then settles.
export function Scramble({ text, ms = 300 }) {
  const settle = useMemo(() => Array.from(text, () => Math.random() * ms), [text, ms]);
  const [t, setT] = useState(0);
  useEffect(() => {
    const t0 = performance.now();
    const id = setInterval(() => {
      const e = performance.now() - t0;
      setT(e);
      if (e > ms) clearInterval(id);
    }, 40);
    return () => clearInterval(id);
  }, [ms]);
  if (t > ms) return text;
  return Array.from(text, (c, i) => (c === " " || t >= settle[i] ? c : glyph())).join("");
}

// The key line: decodes, reads cleanly for under 3 s, flashes cyan once, then corrupts back into noise.
export function KeyLine({ onDecoded }) {
  const [phase, setPhase] = useState("decode");
  const [noise, setNoise] = useState(KEY);
  const cb = useRef(onDecoded);
  useEffect(() => {
    const ts = [setTimeout(() => { setPhase("clean"); cb.current && cb.current(); }, 300),
      setTimeout(() => setPhase("flash"), 2550), setTimeout(() => setPhase("corrupt"), 2850)];
    return () => ts.forEach(clearTimeout);
  }, []);
  useEffect(() => {
    if (phase !== "corrupt") return;
    let n = 0;
    const id = setInterval(() => {
      n += 1;
      setNoise((s) => Array.from(s, (c, i) => (Math.random() < 0.35 + n * 0.12 || i < n * 3 ? glyph() : c)).join(""));
      if (n >= 6) { clearInterval(id); setPhase("noise"); }
    }, 25);
    return () => clearInterval(id);
  }, [phase]);
  const live = phase === "clean" || phase === "flash";
  return (
    <span data-testid="clean-frequency-line" data-phase={phase} data-readable={live ? "true" : "false"}
      className={`tracking-[0.14em] ${phase === "flash" ? "log-key-flash" : "text-[color:var(--w1-text)]"}`}>
      {phase === "decode" ? <Scramble text={KEY} /> : live ? KEY : noise}
    </span>
  );
}
